export enum Source {
    OFFICE = "office",
    CHECKOUT = "checkout",
    KIOSK = "kiosk",
    REFUND = "refund",
    GIFT = "gift",
    IMPORT = "import",
    XOLA = "xola",
}

export enum TaxesAndFeesSource {
    OFFICE = "office",
    CHECKOUT = "checkout",
    KIOSK = "kiosk",
}

export const SourceCopy: { [key in Source | TaxesAndFeesSource]: string } = {
    [Source.OFFICE]: "Back Office",
    [Source.CHECKOUT]: "Checkout",
    [Source.KIOSK]: "Kiosk",
    [Source.REFUND]: "Refund",
    [Source.GIFT]: "Gift",
    [Source.IMPORT]: "Import",
    [Source.XOLA]: "Xola",
};

export enum BookingEngineSource {
    VIATOR = "viator",
    GROUPON = "groupon",
    SIMPLENIGHT = "simplenight",
    EXPEDIA = "expedia",
    GETYOURGUIDE = "getyourguide",
    ONCETHERE = "oncethere",
}

// These booking engines will stored in these name instead of Plugin id in Purchase source
export enum BookingEngineNamedSource {
    VIATOR = "viator",
    EXPEDIA = "expedia",
    EXPEDITION = "expedition",
}

export const BookingEngineNamedSourceCopy: { [key in BookingEngineNamedSource]: string } = {
    [BookingEngineNamedSource.VIATOR]: "Viator & TripAdvisor",
    [BookingEngineNamedSource.EXPEDIA]: "Expedia",
    [BookingEngineNamedSource.EXPEDITION]: "Project Expedition",
};
